import { useLayoutEffect, useState } from 'react';

const PARTNER_PROFILE_TAB_EXPERTISES = 'expertises';
const PARTNER_PROFILE_TAB_OVERVIEW = 'overview';

const constants = Object.freeze({
  PARTNER_PROFILE_TAB_EXPERTISES: PARTNER_PROFILE_TAB_EXPERTISES,
  PARTNER_PROFILE_TAB_OVERVIEW: PARTNER_PROFILE_TAB_OVERVIEW,
  PARTNER_PROFILE_TAB_DEFAULT: PARTNER_PROFILE_TAB_EXPERTISES
});

export default function usePartnerProfileTabNavigation() {

  const [partnerProfileActiveTab, setPartnerProfileActiveTab] = useState(constants.PARTNER_PROFILE_TAB_DEFAULT);
  const [canBeUsed, setCanBeUsed] = useState(false);

  function navigateToExpertises() {
    if(partnerProfileActiveTab !== constants.PARTNER_PROFILE_TAB_EXPERTISES) {
      if(!canBeUsed) { setCanBeUsed(true); }
      setPartnerProfileActiveTab(constants.PARTNER_PROFILE_TAB_EXPERTISES);
    }
  }

  function navigateToOverview() {
    if(partnerProfileActiveTab !== constants.PARTNER_PROFILE_TAB_OVERVIEW)
      if(!canBeUsed) { setCanBeUsed(true);  }
      setPartnerProfileActiveTab(constants.PARTNER_PROFILE_TAB_OVERVIEW);
  }

  function isExpertisesTabActive() {
    return partnerProfileActiveTab === constants.PARTNER_PROFILE_TAB_EXPERTISES;
  }

  function isOverviewTabActive() {
    return partnerProfileActiveTab === constants.PARTNER_PROFILE_TAB_OVERVIEW;
  }

  useLayoutEffect(
    () => {
      if(canBeUsed && !!window) {
        const scrollToElement = window.document.getElementById(partnerProfileActiveTab);
        if(!!scrollToElement) {
          scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
      }
    },
    [partnerProfileActiveTab, canBeUsed]
  );


  return {
    partnerProfileActiveTab,
    navigateToExpertises,
    navigateToOverview,
    isExpertisesTabActive,
    isOverviewTabActive
  }
}
